export default "__VITE_ASSET__DSg6foyw__"